const fetch = require('isomorphic-fetch')
const { isDev } = require('./ambient/utils')

const RAINWISE_API_URL = `https://${isDev() ? 'admindev' : 'diagnostics'}.rainwise.net/mk4`
// const RAINWISE_API_URL = 'https://devapp.rainwise.net/mk4'

async function postToRainWise(data = {}) {
  // TODO NPS remove console logs....  maybe leave resopnse if error?
  // console.log("###============================###")
  // console.log("Data to send")
  // console.log(data)
  try {
    const response = await fetch(RAINWISE_API_URL, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data)
    });
    // TODO NPS --- exception handling?????  try / catch ???  resp == 40x???
    const rainwiseResponse = response.json()
  
    if ((response.status != '200') && (response.status != '204')) {
      console.log('ERROR: postToRainWise resulted in response status ' + response.status);
    } 
    // console.log("###----------------------------###")  
    // console.log("Response from RainWise")
    // console.log(rainwiseResponse)
    // console.log("###============================###")  
    return rainwiseResponse;
  } catch (error) {
    return ({})
    console.error('ERROR: postToRainWise failed with error: ' + error);
  }
}

async function getRainWiseDeviceInfo(mac, ignoreSerial = true) {
  const cleanMac = mac.replace(/:/g, '')
  const url = `${RAINWISE_API_URL}?mac=${cleanMac}&ignore_serial=${ignoreSerial}`

  try {
    const response = await fetch(url)
    if (!response.ok) {
      console.log('ERROR: getRainWiseDeviceInfo resulted in response status ' + response.status)
    }
    return await response.json()
  } catch (error) {
    console.error('ERROR: getRainWiseDeviceInfo failed with error: ' + error)
    return {}
  }
}

export { postToRainWise, getRainWiseDeviceInfo };